/**
 * Utility functions for loading static data files
 */

/**
 * Transform fire station data for map display
 * @param {Array} stations - Array of fire station objects
 * @returns {Array} - Transformed data for map plotting
 */
export function transformFireStationsForMap(stations) {
    return stations.map(station => ({
        coordinates: station.location,
        title: station.station,
        address: station.address_full,
        id: station.id,
        command_center: station.command_center,
        district: station.district,
        municipality: station.municipality,
        year_built: station.year_built,
        ward_number: station.ward_number,
        ward_name: station.ward_name,
        units: station.units
    }));
} 